import React from 'react'
import PropTypes from 'prop-types'
import RcCalendar from 'rc-calendar'
import { mergeProps } from 'src/util'
import { useRcCalendarLocale } from 'src/hooks'
import styles from './Calendar.scss'

const Calendar = ({ value, events, color, footer, ...domProps }) => (
  <RcCalendar
    showDateInput={false}
    showFooter={false}
    showToday={false}
    locale={useRcCalendarLocale()}
    value={value}
    selectedValue={value}
    renderFooter={() => footer}
    dateRender={date => {
      const event = events.find(({ start, end }) => date.isBetween(start, end, 'day', '[]'))
      const color = event ? event.color : ''
      return <div className={`rc-calendar-date ${color}`}>{date.get('date')}</div>
    }}
    {...mergeProps()({ className: styles.calendar }, domProps)}
  />
)

Calendar.defaultProps = {
  events: [],
  color: 'secondary-light',
}

Calendar.propTypes = {
  value: PropTypes.any,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.any,
      end: PropTypes.any,
      color: PropTypes.string,
    })
  ),
  color: PropTypes.string,
  footer: PropTypes.node,
}

export default Calendar
